import { render, staticRenderFns } from "./ProductDropdownMenu.vue?vue&type=template&id=0ba5fb4a&scoped=true&"
import script from "./ProductDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./ProductDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductDropdownMenu.vue?vue&type=style&index=0&id=0ba5fb4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5fb4a",
  null
  
)

export default component.exports